import React from 'react';
import { Alert, Typography } from '@mui/material';

export const UploadGuidelinesSection: React.FC = () => (
  <Alert
    severity="info"
    sx={{
      backgroundColor: '#f0f9ff',
      border: '1px solid #bae6fd',
    }}
  >
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      Upload guidelines:
    </Typography>
    <Typography variant="body2" sx={{ mt: 1 }}>
      • Documents will be stored securely in Azure blob storage
      <br />
      • All uploaded files are associated with this refund request
      <br />
      • Supported formats: PDF, Word, Excel, Images, and Text files
      <br />• Maximum file size: 10MB per document
    </Typography>
  </Alert>
);

export default UploadGuidelinesSection;
